import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var align_right_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M11.111 5.5H20V4h-8.889v1.5ZM4 12.5h16V11H4v1.5Zm7.111 7H20V18h-8.889v1.5Z" }) });
export {
  align_right_default as default
};
//# sourceMappingURL=align-right.js.map
